(function () {
  const activeCountdowns = new Set();
  let tickTimerId = null;
  let stopTimerId = null;
  let mountIdCounter = 0;

  function parseCountdownEnd(root) {
    if (!root || !root.dataset.date) return NaN;

    const timezone = root.dataset.timezone;
    const date = root.dataset.date.split('-').filter(function (el) {
      return el !== '';
    });
    const day = parseInt(date[0], 10);
    const month = parseInt(date[1], 10);
    const year = parseInt(date[2], 10);

    let tarhour = 0;
    let tarmin = 0;

    if (root.dataset.time) {
      const time = root.dataset.time.split(':');
      tarhour = parseInt(time[0], 10);
      tarmin = parseInt(time[1], 10);
    }

    const dateString =
      month +
      '/' +
      day +
      '/' +
      year +
      ' ' +
      (tarhour < 10 ? '0' + tarhour : tarhour) +
      ':' +
      (tarmin < 10 ? '0' + tarmin : tarmin) +
      ' GMT' +
      timezone;

    const endTime = new Date(dateString).getTime();
    return Number.isFinite(endTime) ? endTime : NaN;
  }

  function pad(value) {
    return value < 10 && value >= 0 ? '0' + value : String(value);
  }

  function hideFlashSale(flashSale) {
    flashSale.hidden = true;
    flashSale.setAttribute('aria-hidden', 'true');

    const cardWrap = flashSale.closest('.product-card__flash-promo');
    if (cardWrap) {
      cardWrap.hidden = true;
      cardWrap.setAttribute('aria-hidden', 'true');
    }

    const pdpWrap = flashSale.closest('.product__flash-promo');
    if (pdpWrap) {
      pdpWrap.hidden = true;
      pdpWrap.setAttribute('aria-hidden', 'true');
    }
  }

  function isFlashSaleTracked(flashSale) {
    for (const entry of activeCountdowns) {
      if (entry.flashSale === flashSale) return true;
    }
    return false;
  }

  function pruneDisconnectedCountdowns() {
    activeCountdowns.forEach(function (entry) {
      if (!entry.flashSale.isConnected) {
        activeCountdowns.delete(entry);
      }
    });
  }

  function removeCountdown(flashSale) {
    activeCountdowns.forEach(function (entry) {
      if (entry.flashSale === flashSale) {
        activeCountdowns.delete(entry);
      }
    });
    delete flashSale.dataset.flashPromoInitialized;
  }

  function updateCountdown(countdownRoot) {
    const endTime = parseCountdownEnd(countdownRoot);
    if (!Number.isFinite(endTime)) {
      return false;
    }

    const distance = endTime - Date.now();

    if (distance < 0) {
      return false;
    }

    const totalSeconds = Math.floor(distance / 1000);
    const totalHours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const hoursEl = countdownRoot.querySelector('[data-flash-promo-unit="hours"]');
    const minutesEl = countdownRoot.querySelector('[data-flash-promo-unit="minutes"]');
    const secondsEl = countdownRoot.querySelector('[data-flash-promo-unit="seconds"]');

    if (hoursEl) hoursEl.textContent = pad(totalHours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);

    return true;
  }

  function cancelStopTimer() {
    if (stopTimerId) {
      window.clearTimeout(stopTimerId);
      stopTimerId = null;
    }
  }

  function scheduleStopTimer() {
    cancelStopTimer();
    stopTimerId = window.setTimeout(function () {
      pruneDisconnectedCountdowns();
      if (activeCountdowns.size === 0) {
        stopTickLoop();
      }
    }, 250);
  }

  function tickAllCountdowns() {
    pruneDisconnectedCountdowns();

    if (activeCountdowns.size === 0) {
      scheduleStopTimer();
      return;
    }

    cancelStopTimer();

    activeCountdowns.forEach(function (entry) {
      try {
        if (!entry.flashSale.isConnected || !entry.countdownRoot.isConnected) {
          activeCountdowns.delete(entry);
          delete entry.flashSale.dataset.flashPromoInitialized;
          return;
        }

        if (!updateCountdown(entry.countdownRoot)) {
          hideFlashSale(entry.flashSale);
          removeCountdown(entry.flashSale);
        }
      } catch (error) {
        console.error('Flash promo countdown tick error', error);
        removeCountdown(entry.flashSale);
      }
    });

    if (activeCountdowns.size === 0) {
      scheduleStopTimer();
    } else {
      ensureTickLoop();
    }
  }

  function stopTickLoop() {
    if (tickTimerId) {
      window.clearTimeout(tickTimerId);
      tickTimerId = null;
    }
  }

  function scheduleNextTick() {
    stopTickLoop();
    tickTimerId = window.setTimeout(function () {
      tickAllCountdowns();
      if (activeCountdowns.size > 0) {
        scheduleNextTick();
      }
    }, 1000);
  }

  function ensureTickLoop() {
    if (!tickTimerId && activeCountdowns.size > 0) {
      scheduleNextTick();
    }
  }

  function initFlashSale(flashSale, options) {
    let force = options && options.force;

    if (!flashSale) return;

    if (
      !force &&
      flashSale.dataset.flashPromoInitialized === 'true' &&
      isFlashSaleTracked(flashSale)
    ) {
      return;
    }

    if (
      flashSale.dataset.flashPromoInitialized === 'true' &&
      !isFlashSaleTracked(flashSale)
    ) {
      force = true;
    }

    if (!force && flashSale.dataset.flashPromoInitialized === 'true') return;
    if (window.Shopify && window.Shopify.designMode) return;

    const countdownRoot = flashSale.querySelector('[data-product-flash-promo-countdown]');
    if (!countdownRoot) return;

    removeCountdown(flashSale);

    if (!updateCountdown(countdownRoot)) {
      hideFlashSale(flashSale);
      return;
    }

    flashSale.hidden = false;
    flashSale.removeAttribute('aria-hidden');

    const cardWrap = flashSale.closest('.product-card__flash-promo');
    if (cardWrap) {
      cardWrap.hidden = false;
      cardWrap.removeAttribute('aria-hidden');
    }

    flashSale.dataset.flashPromoInitialized = 'true';
    activeCountdowns.add({ countdownRoot: countdownRoot, flashSale: flashSale });
    cancelStopTimer();
    ensureTickLoop();
  }

  function parseFlashPromoVariantIds(value) {
    return (value || '')
      .split(',')
      .map(function (id) {
        return id.trim();
      })
      .filter(Boolean);
  }

  function isOfertasDelDiaEligible(productLevel, variantIds, variantId) {
    if (productLevel === 'true') return true;
    if (variantId == null || variantId === '') return false;
    return parseFlashPromoVariantIds(variantIds).indexOf(String(variantId)) !== -1;
  }

  function isCardFlashPromoInScope(card) {
    if (!card) return false;

    if (card.dataset.flashPromoProduct === undefined) {
      return card.dataset.flashPromoEligible === 'true';
    }

    if (card.dataset.flashPromoProduct === 'true') return true;
    if (card.dataset.flashPromoEligible === 'true') return true;

    return parseFlashPromoVariantIds(card.dataset.flashPromoVariantIds).length > 0;
  }

  function getCardVariantId(card) {
    const match = card.querySelector('[data-product-link]')?.href?.match(/variant=(\d+)/);
    return match ? match[1] : null;
  }

  function setFlashPromoWrapVisible(wrap, visible) {
    if (!wrap) return;

    wrap.hidden = !visible;
    wrap.setAttribute('aria-hidden', visible ? 'false' : 'true');

    const flashSale = wrap.querySelector('[data-product-flash-promo]');
    if (!flashSale) return;

    if (visible) {
      flashSale.hidden = false;
      flashSale.removeAttribute('aria-hidden');
      initFlashSale(flashSale, { force: !isFlashSaleTracked(flashSale) });
    } else {
      hideFlashSale(flashSale);
    }
  }

  function updateCardFlashPromoForVariant(card) {
    if (!card || card.dataset.flashPromoProduct === undefined) return;

    if (!isCardFlashPromoInScope(card)) {
      delete card.dataset.flashPromoEligible;
      setFlashPromoWrapVisible(card.querySelector('.product-card__flash-promo'), false);
      return;
    }

    card.dataset.flashPromoEligible = 'true';
    const wrap = card.querySelector('.product-card__flash-promo');
    setFlashPromoWrapVisible(wrap, true);
    mountFlashPromoOnCard(card);
  }

  function getPdpSelectedVariantId() {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get('variant');
    if (fromUrl) return fromUrl;

    const productInfo = document.querySelector('product-info');
    if (productInfo && typeof productInfo.getSelectedVariant === 'function') {
      const variant = productInfo.getSelectedVariant(productInfo);
      if (variant && variant.id != null) return String(variant.id);
    }

    const variantInput =
      document.querySelector('product-info form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (variantInput && variantInput.value) return variantInput.value;

    return null;
  }

  function updatePdpFlashPromo(variant) {
    const variantId = variant && variant.id != null ? variant.id : null;
    if (variantId == null || variantId === '') return;

    document.querySelectorAll('[data-flash-promo-eligibility]').forEach(function (wrap) {
      const visible = isOfertasDelDiaEligible(
        wrap.dataset.flashPromoProduct,
        wrap.dataset.flashPromoVariantIds,
        variantId
      );
      setFlashPromoWrapVisible(wrap, visible);
    });
  }

  function syncPdpFlashPromoOnLoad() {
    const wraps = document.querySelectorAll('[data-flash-promo-eligibility]');
    if (!wraps.length) return;

    const variantId = getPdpSelectedVariantId();
    if (variantId) {
      updatePdpFlashPromo({ id: variantId });
      return;
    }

    wraps.forEach(function (wrap) {
      if (wrap.hidden) return;
      setFlashPromoWrapVisible(wrap, true);
    });
  }

  function createMountId(card) {
    mountIdCounter += 1;
    const productId = card.dataset.productId || 'product';
    const variantId = getCardVariantId(card) || 'default';
    return productId + '-' + variantId + '-' + mountIdCounter;
  }

  function isCardFlashPromoEligible(card) {
    return isCardFlashPromoInScope(card);
  }

  function mountFlashPromoOnCard(card) {
    if (!isCardFlashPromoEligible(card)) return;

    const existingPromo = card.querySelector('[data-product-flash-promo]');
    if (existingPromo) {
      initFlashSale(existingPromo, { force: !isFlashSaleTracked(existingPromo) });
      return;
    }

    const template = document.getElementById('flash-promo-card-shell-template');
    if (!template || !template.innerHTML.trim()) return;

    const mountId = createMountId(card);
    const parsed = document.createElement('div');
    parsed.innerHTML = template.innerHTML.replace(/__FLASH_PROMO_ID__/g, mountId);
    const mountNode = parsed.firstElementChild;
    if (!mountNode) return;

    const flashSale = mountNode.querySelector('[data-product-flash-promo]');
    if (!flashSale) return;

    const existingWrap = card.querySelector('.product-card__flash-promo');
    if (existingWrap) {
      existingWrap.replaceChildren(flashSale);
      existingWrap.hidden = false;
      existingWrap.removeAttribute('aria-hidden');
    } else {
      const content = card.querySelector('.product-card__content');
      if (content) {
        card.insertBefore(mountNode, content);
      } else {
        card.appendChild(mountNode);
      }
    }

    initFlashSale(flashSale, { force: true });
  }

  function mountMissingFlashPromos(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('product-card').forEach(function (card) {
      if (isCardFlashPromoEligible(card)) {
        mountFlashPromoOnCard(card);
      }
    });

    if (scope && scope.matches && scope.matches('product-card') && isCardFlashPromoEligible(scope)) {
      mountFlashPromoOnCard(scope);
    }
  }

  function initFlashPromoInScope(scope) {
    mountMissingFlashPromos(scope);

    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-product-flash-promo]').forEach(function (flashSale) {
      initFlashSale(flashSale, { force: !isFlashSaleTracked(flashSale) });
    });

    if (scope && scope.matches && scope.matches('[data-product-flash-promo]')) {
      initFlashSale(scope, { force: !isFlashSaleTracked(scope) });
    }
  }

  function refreshFlashPromoInScope(scope) {
    queueMicrotask(function () {
      initFlashPromoInScope(scope);
      const root = scope && scope.querySelector ? scope : document;
      if (
        root === document ||
        (root.matches && root.matches('[data-flash-promo-eligibility]')) ||
        (root.querySelector && root.querySelector('[data-flash-promo-eligibility]'))
      ) {
        syncPdpFlashPromoOnLoad();
      }
      ensureTickLoop();
    });
  }

  function nodeNeedsFlashPromoRefresh(node) {
    if (node.nodeType !== 1) return false;

    if (node.matches) {
      if (
        node.matches('[data-product-flash-promo]') ||
        node.matches('product-card')
      ) {
        return true;
      }
    }

    if (node.querySelector) {
      return !!(
        node.querySelector('[data-product-flash-promo]') ||
        node.querySelector('product-card')
      );
    }

    return false;
  }

  function setupMutationObserver() {
    if (typeof MutationObserver === 'undefined') return;

    const productGrid = document.getElementById('product-grid');
    const observeTarget = productGrid || document.body;

    const observer = new MutationObserver(function (mutations) {
      let shouldRefresh = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (nodeNeedsFlashPromoRefresh(node)) {
            shouldRefresh = true;
          }
        });
      });

      if (shouldRefresh) {
        refreshFlashPromoInScope(observeTarget);
      }
    });

    observer.observe(observeTarget, { childList: true, subtree: true });
  }

  function isProductListingPage() {
    return !!document.getElementById('product-grid');
  }

  function setupVariantifyCompat() {
    if (!isProductListingPage()) return;

    let passes = 0;
    const maxPasses = 16;

    const retry = function () {
      refreshFlashPromoInScope(document.getElementById('product-grid') || document);
      passes += 1;
      if (passes < maxPasses) {
        window.setTimeout(retry, passes < 6 ? 400 : 800);
      }
    };

    window.setTimeout(retry, 300);
    window.setTimeout(retry, 1200);
    window.setTimeout(retry, 2500);

    window.addEventListener('load', function () {
      window.setTimeout(function () {
        refreshFlashPromoInScope(document.getElementById('product-grid') || document);
      }, 400);
    });

    const variantifyEvents = [
      'variantify:ready',
      'variantify:rendered',
      'variantify:updated',
      'variantify:complete',
      'variantify-split:ready',
      'variantify-split:rendered'
    ];

    variantifyEvents.forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        refreshFlashPromoInScope(document.getElementById('product-grid') || document);
      });
    });
  }

  function initAll() {
    refreshFlashPromoInScope(document);
  }

  window.ProductFlashPromo = {
    init: refreshFlashPromoInScope,
    refresh: initAll,
    mount: mountMissingFlashPromos,
    updateCardForVariant: updateCardFlashPromoForVariant,
    updatePdpForVariant: updatePdpFlashPromo
  };

  function setupVariantChangeListener() {
    if (typeof subscribe !== 'function') return;

    subscribe('variant-change', function (payload) {
      const variant = payload?.data?.variant;
      if (variant) {
        updatePdpFlashPromo(variant);
      }
    });
  }

  function bootstrap() {
    initAll();
    syncPdpFlashPromoOnLoad();
    setupMutationObserver();
    setupVariantifyCompat();
    setupVariantChangeListener();
  }

  document.addEventListener('product-info:loaded', function () {
    syncPdpFlashPromoOnLoad();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      refreshFlashPromoInScope(event.target);
    }
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      initAll();
    }
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      initAll();
    }
  });
})();
